// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2m23o","toggle":"styles_toggle__Ffsi5","preview":"styles_preview__2E_2I"};